import { NextSeo } from 'next-seo';
import Container from '@/components/Container';
import PageHeader from '@/components/PageHeader';
import SupportForm from '@/components/support/SupportForm';
import SupportLinks from '@/components/support/SupportLinks';

const SupportPage = () => {
  return (
    <>
      <NextSeo
        title='Support | Shitty Kitties'
        description='Get help with Shitty Kitties - submit feedback, report bugs, or ask questions about our NFT ecosystem on Algorand.'
      />

      <PageHeader heading='Need Help?' description="Got questions, feedback, or found a bug? We're here to help." />

      <Container>
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 pb-16 lg:pb-24'>
          <div className='lg:col-span-2'>
            <SupportForm />
          </div>
          <div className='lg:col-span-1'>
            <SupportLinks />
          </div>
        </div>
      </Container>
    </>
  );
};

export default SupportPage;
